module.exports = __webpack_public_path__ + "static/img/background.99d1fb27.svg";